const content: { [key: string]: any } = {
  title: {
    pageTitle: "Birthdays",
    pageDescription: "ABOs celebrating a birthday this month and in the following two months.",
  },
  sections: {
    thisMonth: "This Month",
    birthdaysNextMonth: "Birthdays Next Month",
    birthdayInMonth: "Birthdays in {month}",
  },
  filter: {
    groupLeader: {
      allOption: "All ABOs",
    },
  },
  export: {
    button: "Export",
    description:
      "This Report will include a list of ABOs celebrating a birthday this month and in the following two months.",
    exportTypeLabel: "Birthday",
  },
  table: {
    columns: {
      applicantName: "Applicant Name / Number",
      birthDate: "Date Of Birth",
      bonusPercent: "Performance Bonus %",
      groupPV: "Group PV",
    },
  },
  confidentialUser: "Confidential User",
} as const;

export default content;
